import { Component } from '@angular/core';

@Component({
  selector: 'gea-id-workspace-about-gea',
  templateUrl: './about-gea.component.html',
  styleUrls: ['./about-gea.component.scss'],
  standalone: false,
})
export class AboutGeaComponent {}
